module.exports = __webpack_public_path__ + "img/reference-treibstoff.207cbddb.webp";